import Lang from "@vendors-fr/messages";
import {waca} from "@plugins-fr/regExp";
import 'jquery-confirm';
import 'jquery-match-height';
import 'jquery-ui/dist/jquery-ui';
import '@vendors-fr/jquery.twzipcode';
import '@commons-fr/combobox';
import {AlertMessage} from '@plugins-fr/alertMessage';
import {TempusDominus} from "@eonasdan/tempus-dominus";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {addScript} from "../tracking/thirdPartyTracker";
import {ShopAtmIsPay} from "./shopAtmIsPay";
import {ChangeStore, EcPayChangeStoreData, PayNowChangeStoreData} from "./changeStore";
import {
    ProductCustomField, ProductCustomFieldComponent,
    ProductCustomFieldDataContainerHelper,
    ProductCustomFieldDataStorage
} from "@plugins-fr/CustomFields";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";
import {
    orderPageCancelOrderSubmit,
    orderPageUpdateOrderSubmit,
    orderSearchPageSubmit
} from "@commons/userTracks/eventActionName";


$(function() {
    var JS_VARS = JSON.parse(shops);
    var JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);

    //訂單有商品自訂自訂欄位
    if (typeof JS_VARS.productCustomFieldForms !== 'undefined' && JS_VARS.productCustomFieldForms.length > 0) {

        const productForms = JS_VARS.productCustomFieldForms;
        const productAppliedCustomFields = JS_VARS.productAppliedCustomFields
        ProductCustomFieldDataContainerHelper.setProductForms(productForms);
        ProductCustomFieldDataContainerHelper.setCustomFields(productAppliedCustomFields);

        ProductCustomFieldDataStorage.deleteAllStage();
        ProductCustomFieldComponent.view.list.removeAll();

        productForms.forEach((productForm) => {
            let id = productForm.cartItemId;
            if (typeof productAppliedCustomFields[id] === 'undefined') {
                return;
            }
            let productAppliedCustomField = productAppliedCustomFields[id];

            ProductCustomFieldDataStorage.reInstallStorage(productAppliedCustomField, id);

            let productCustomFields = new ProductCustomField({
                id: id,
                productForm: Object.assign({}, productForm),
                customFields: [...productAppliedCustomFields[id]],
                isMobile: JS_VARS.isMobile === 1,
                isReview: JS_VARS.hasReservationList === 1,
                isUpdate: JS_VARS.hasReservationList !== 1,
                updateCallback: reloadPage
            });
            ProductCustomFieldComponent.method.setProductCustomField(productCustomFields);
            ProductCustomFieldComponent.method.initialRender();
            ProductCustomFieldComponent.method.displayFormStyle();
            productCustomFields.bindEvent();
        });
    }

    if (JS_VARS.message != '' || (typeof JS_VARS.subscriptionMessage != 'undefined' && JS_VARS.subscriptionMessage != '')) {
        var alertMessage = JS_VARS.message != '' ? JS_VARS.message : JS_VARS.subscriptionMessage;

        new AlertMessage({
            'title': alertMessage,
        }).handle();
    }


    var orderErrorMessage = {
        'IsRequired': Lang.get('frontend.errormsg.isRequired'),
        'codeIsNumber': (JS_VARS.is_inquiry ? Lang.get('frontend.errormsg.order.inquiry.order_no.format') : Lang.get('frontend.errormsg.order.order.order_no.format')),
        'vcodeIsNumber': Lang.get('frontend.errormsg.order.order.vcode.format'),
        'phonetIsNumber': Lang.get('frontend.errormsg.order.order.phone.format'),
        'addressFormat' : Lang.get('frontend.errormsg.address.format'),
        'nameFormat' : Lang.get('frontend.errormsg.cart.name.format'),
        'phoneFormat' : Lang.get('frontend.errormsg.cart.phone.format1'),
        'phoneIsRequired' : Lang.get('frontend.errormsg.cart.phone.isRequired'),
        'zipFormat' : Lang.get('frontend.errormsg.address.zip.format'),
        'paymentAtFormat': Lang.get('frontend.errormsg.order.order.payment_at.format'),
        'emailFormat': Lang.get('frontend.errormsg.cart.email.format'),
        'updateReceiver' : Lang.get('errormsg.order.updateReceiver.error'),
        'customQuestionMaxLength' : Lang.get('frontend.errormsg.custom.question.maxlength'),
        'cannotContainAsterisk' : Lang.get('frontend.errormsg.cannot.contain.asterisk'),
    };

    /**
     *  顯示錯誤訊息
     */
    var showErrorMessage = function(FieldName, ErrorName){
        FieldName.addClass('form_valid');
        FieldName.find('.js_order_message').find('span').html(ErrorName);

    };

    /**
     *  隱藏錯誤訊息
     */
    var hideErrorMessage = function(FieldName){
        FieldName.removeClass('form_valid');
    };

    /**
     *  檢查訂單編號欄位
     */
    var noCheck = function(){
        var order_no = $.trim($('.js_order_no').val());

        if (order_no == '') {
            showErrorMessage($('.js_order_no_group'), orderErrorMessage.IsRequired);
            return false;
        } else if (! waca.regexValidator.englishAndNumber(order_no)) {
            showErrorMessage($('.js_order_no_group'), orderErrorMessage.codeIsNumber);
            return false;
        }
        hideErrorMessage($('.js_order_no_group'));
        return true;
    };

    /**
     *  檢查認證碼欄位
     */
    var vcodeCheck = function(){
        var vcode = $.trim($('.js_order_validate_code').val());
        if (vcode == '') {
            showErrorMessage($('.js_order_validate_code_group'), orderErrorMessage.IsRequired);
            return false;
        } else if (! waca.regexValidator.englishAndNumber(vcode)) {
            showErrorMessage($('.js_order_validate_code_group'), orderErrorMessage.vcodeIsNumber);
            return false;
        }
        hideErrorMessage($('.js_order_validate_code_group'));
        return true;
    };

    /**
     *  檢查電話欄位
     */
    var phonetCheck = function(){
        var phonet = $.trim($('.js_order_phone').val());
        if (phonet == '') {
            showErrorMessage($('.js_order_phone_group'), orderErrorMessage.IsRequired);
            return false;
        }

        hideErrorMessage($('.js_order_phone_group'));
        return true;
    };


    // 分開檢查欄位，預防使用者需按兩次才能查詢訂單 by rita 2015-06-16
    $('.js_order_no').change(function(){
        noCheck();
    });
    $('.js_order_validate_code').change(function(){
        vcodeCheck();
    });
    $('.js_order_phone').change(function(){
        phonetCheck();
    });

    // 訂單查詢
    $('.js_order_search').click(function(){
        var order_no = $('.js_order_no').val();
        var order_validate_code = $('.js_order_validate_code').val();

        var noCheckStatus = noCheck();
        var vcodeCheckStatus = vcodeCheck();
        var phonetCheckStatus = phonetCheck();
        if ((noCheckStatus && vcodeCheckStatus) || phonetCheckStatus) {
            recordUserEventTrack(orderSearchPageSubmit, $(this).closest('form').attr('action'), {
                'order_no': String(order_no),
            });
            return true;
        }
        return false;
    });

    // 回首頁
    $('.js_back_index').click(function(){
        location.href = JS_VARS.urls.index;
    });

    // 回會員中心
    $('.js_back_member').click(function(){
        location.href = JS_VARS.urls.member;
    });

    if ($('.js_ispay_button').length > 0) {
        let hasPayTime = typeof JS_VARS.shops_atm['pay_time'] != 'undefined' && JS_VARS.shops_atm['pay_time'] == '1';

        (new ShopAtmIsPay({
            'orderNo': $('.no').val(),
            'locale': JS_VARS.getLocale,
            'shopAtm': JS_VARS.shops_atm,
            'hasPayTime': hasPayTime,
            'orderATMAjaxUrl': JS_VARS.urls.orderATM,
            'orderQueryToken': JS_VARS.orderQueryToken,
            'successCallback': () => {
                reloadPage();
            },
        })).bindEvents();
    }

    // 取消訂單
    $('.js_order_close').click(function() {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-5 col-xl-4',
            content: false,
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: (JS_VARS.is_inquiry ? Lang.get('frontend.order.inquiry.toCancle.info') : Lang.get('frontend.order.order.toCancle.info')),
            backgroundDismiss: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function() {
                        $.ajax({
                            type: 'POST',
                            url: JS_VARS.urls.orderCancel,
                            data: {
                                no: $('.no').val(),
                                order_query_token: JS_VARS.orderQueryToken
                            },
                            success: function(data){
                                if (data.error == 0) {
                                    if (data.trace) {
                                        addScript('refund', data.trace);
                                    }

                                    recordUserEventTrack(orderPageCancelOrderSubmit, JS_VARS.urls.orderCancel, {
                                        'order_no': String($('.no').val()),
                                    });

                                    new AlertMessage({
                                        'title': data.message,
                                        confirm: function(){
                                            reloadPage();
                                        }
                                    }, {
                                        'type': 'success'
                                    }).handle();
                                } else {
                                    new AlertMessage({
                                        'title': data.message
                                    }).handle();
                                }
                            },
                            dataType: 'json'
                        });
                        return true;
                    },
                }
            },
            onOpenBefore: function() {
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.confirmButtonHoverStyle);

                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                this.$el.find('.btn_cancel, .btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            }
        });

        return false;
    });

    if ($('.js_paynow_update_store_btn').length > 0) {
        (new ChangeStore(PayNowChangeStoreData, {
            'JS_VARS_THEME_STYLE': JS_VARS_THEME_STYLE,
            'changeStoreButtonClass': '.js_paynow_update_store_btn',
            'saveStoreButtonClass': '.js_save_payNow_store',
            'changeStoreFormPrefix': '.payNow',
            'modifyPackingListId': JS_VARS.modifyPackingListId,
            'changeStoreAjaxUrl': JS_VARS.urls.changePaynowStore,
            'orderNo': $('.no').val(),
            'orderQueryToken': JS_VARS.orderQueryToken,
            'successCallback': (response) => {
                new AlertMessage({
                    'title': response.message,
                    'confirm': function(){
                        reloadPage();
                    }
                }, {
                    'type': response.error === 1 ? 'error' : 'success'
                }).handle();
            }
        })).bindEvents();
    }

    if ($('.js_update_allPay_store').length > 0) {
        (new ChangeStore(EcPayChangeStoreData, {
            'JS_VARS_THEME_STYLE': JS_VARS_THEME_STYLE,
            'changeStoreButtonClass': '.js_update_allPay_store',
            'saveStoreButtonClass': '.js_save_allPay_store',
            'changeStoreFormPrefix': '.allPay',
            'modifyPackingListId': JS_VARS.modifyPackingListId,
            'changeStoreAjaxUrl': JS_VARS.urls.changeStore,
            'orderNo': $('.no').val(),
            'orderQueryToken': JS_VARS.orderQueryToken,
            'successCallback': (response) => {
                new AlertMessage({
                    'title': response.message,
                    'confirm': function(){
                        reloadPage();
                    }
                }, {
                    'type': response.error === 1 ? 'error' : 'success'
                }).handle();
            }
        })).bindEvents();
    }


    var receiverInfo = {
        init : function() {
            if (JS_VARS.isEnableChangeAddress) {
                $('.js_receiver_input').removeClass('d-none');
                $('.js_receiver_text').hide();
                $('.js_change_address_submit').unbind().click(function() {
                    receiverInfo.validateAndSubmit();
                }).text(Lang.get('frontend.order.receiverInfo.modify'));
                this.initTwzipcode();
                this.recordMaskValues('address');
                this.initInternationalReceiverAddress();
                this.initGlobalAddress();
            } else if(JS_VARS.is_enable_change_recipient == 1) {
                $('.js_recipient_input').removeClass('d-none');
                $('.js_recipient_text').hide();
                $('.js_change_address_submit').unbind().click(function() {
                    receiverInfo.validateAndSubmit();
                }).text(Lang.get('frontend.order.receiverInfo.modify'));
                this.initTwzipcode();
                this.recordMaskValues('recipient');
                this.initInternationalReceiverAddress();
                this.initGlobalAddress();
            }
        },
        initTwzipcode : function() {
            if (JS_VARS.is_address_in_taiwan == 1) {
                var hideCounty = [];
                var hideDistrict = [];
                var hideDistrictByWaca = [];

                if (JS_VARS.shipping.indexOf('custom_') >= 0) {
                    switch (JS_VARS.shipping_scope) {
                        // 台灣外島不寄送
                        case 'twland_not_send':
                            hideCounty = JS_VARS.taiwanOuterIsland['county'];
                            hideDistrictByWaca = JS_VARS.taiwanOuterIsland['district'];

                            if (hideCounty.length > 0) {
                                var countyIndex = hideCounty.indexOf(JS_VARS.receiver_address['receiver_city']);
                                if (countyIndex >= 0) {
                                    hideCounty.splice(countyIndex, 1);
                                }
                            }
                            if (typeof hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']] !== 'undefined') {
                                var districtIndex = hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']].indexOf(JS_VARS.receiver_address['receiver_district']);
                                if (districtIndex >= 0) {
                                    hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']].splice(districtIndex, 1);
                                }
                            }

                            break;
                        // 指定台灣縣市區域
                        case 'taiwan_district_limit':
                            hideCounty = JS_VARS.taiwan_district_limit['hideCounty'] || [];
                            hideDistrictByWaca = JS_VARS.taiwan_district_limit['hideDistrict'] || [];

                            if (hideCounty.length > 0) {
                                var countyIndex = hideCounty.indexOf(JS_VARS.receiver_address['receiver_city']);
                                if (countyIndex >= 0) {
                                    hideCounty.splice(countyIndex, 1);
                                }
                            }
                            if (typeof hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']] !== 'undefined') {
                                var districtIndex = hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']].indexOf(JS_VARS.receiver_address['receiver_district']);
                                if (districtIndex >= 0) {
                                    hideDistrictByWaca[JS_VARS.receiver_address['receiver_city']].splice(districtIndex, 1);
                                }
                            }
                            break;
                    }
                }


                $('#js_twzipcode').twzipcode({
                    detect: false,
                    zipcodeIntoDistrict: true,
                    'countySel'   : JS_VARS.receiver_address['receiver_city'],
                    'districtSel' : JS_VARS.receiver_address['receiver_district'],
                    'zipcodeSel'  : '',// 帶空值，預防同個縣市底下的鄉鎮市區有相同的郵遞區號，twzipcode 會抓錯鄉鎮市區預設值的問題
                    'hideCounty'  : hideCounty,
                    'hideDistrict'  : [].concat(...(Object.values(hideDistrictByWaca)))  || [],
                    onCountySelect : function(){$('.js_receiver_district').change();}
                });

                $('.js_twzipcode_wrapper').append('<span class="form_select_bind js_select_bind"></span>');
                $('.js_twzipcode_wrapper').each(function(){
                    var text = $(this).children('.js_select_bind').prev().find("option:selected").text();
                    $(this).children('.js_select_bind').text(text);
                });
            }
        },
        getSubmitData : function() {
            var data = {
                no: $('.no').val(),
                order_query_token: JS_VARS.orderQueryToken,
                is_holiday : $('#is_holiday_send').val(),
                orders_custom_question : {}
            };

            if (JS_VARS.is_international_address == 1) {
                data.receiver_district = $('#receiver_region').val();
                data.receiver_city = $('#receiver_city').val();
                data.receiver_zip = $.trim($('#intReceiverZip').val());
                if (JS_VARS.shipping == 231) {
                    data.receiver_country = $.trim($('#intReceiverCountry').val());
                }
            } else {
                data.receiver_zip = $.trim($('.js_receiver_zip').val());
                data.receiver_city = $('.js_receiver_city').val();
                data.receiver_district = $('.js_receiver_district').val();
            }
            for (var key in this.maskFields) {
                if (this.isMaskChange(key)) {
                    if (key == 'intReceiverAddress') {
                        data['receiver_address'] = $.trim($('#' + key).val());
                    } else if (key.startsWith('orders_custom_question')) {
                        var ocqId = $('#' + key).data('ocq-id');
                        data['orders_custom_question'][ocqId] = $.trim($('#' + key).val());
                    } else {
                        data[key] = $.trim($('#' + key).val());
                    }
                }
            }
            if (JS_VARS.is_time_select == 1) {
                data['shipping_time'] = $.trim($('#shipping_time').val());
            }

            if (JS_VARS.is_date_select == 1) {
                data['shipping_date'] = $.trim($('#shipping_date').val());
            }
            return data;
        },
        changeInfo : function() {
            var data = this.getSubmitData();
            $.ajax({
                url: JS_VARS.urls.changeAddressAjax,
                dataType: 'json',
                type: 'post',
                data: data,
                success: function (response)
                {
                    if (response.error === 0) {
                        recordUserEventTrack(orderPageUpdateOrderSubmit, JS_VARS.urls.changeAddressAjax, {
                            'order_no': String(data.no),
                        });
                        new AlertMessage({
                            'title': response.message,
                            'confirm': function(){
                                reloadPage();
                            }
                        }, {
                            'type': 'success'
                        }).handle();
                    } else {
                        new AlertMessage({
                            'title': response.message,
                            'confirm': function(){
                                reloadPage();
                            }
                        }, {
                            'type': 'error'
                        }).handle();
                    }
                },
                error: function ()
                {
                    new AlertMessage({
                        'title': orderErrorMessage.updateReceiver
                    }).handle();
                }
            });
        },
        maskFields : {},
        setMaskFields : function(key, val){
            this.maskFields[key] = val;
        },
        recordMaskValues : function(type) {
            var self = this;
            this.setMaskFields('receiver_name', $('#receiver_name').val());
            this.setMaskFields('receiver_phone', $('#receiver_phone').val());
            this.setMaskFields('receiver_email', $('#receiver_email').val());
            if (type == 'address') {
                if (JS_VARS.is_international_address == 1) {
                    this.setMaskFields('intReceiverAddress', $('#intReceiverAddress').val());
                } else {
                    this.setMaskFields('receiver_address', $('#receiver_address').val());
                }
            }
            $('.js_orders_custom_question').each(function(){
                var ocqId = $(this).data('ocq-id');
                self.setMaskFields('orders_custom_question' + ocqId, $(this).val());
            });
        },
        validateAndSubmit :function() {
            var is_custom_questions = this.checkCustomQuestions();
            if (JS_VARS.isEnableChangeAddress == 1) {
                var is_receiver_name = this.checkReceiverName();
                var is_receiver_phone = this.checkReceiverPhone();
                if (JS_VARS.is_international_address == 1) {
                    var country = JS_VARS.receiver_address.receiver_country;
                    if (JS_VARS.noneCityCountry.indexOf(country) < 0) {
                        var is_receiver_city = this.checkIntReceiverCity();
                        var is_receiver_district = this.checkIntReceiverDistrict();
                    } else {
                        var is_receiver_city = true;
                        var is_receiver_district = true;
                    }
                    var is_receiver_zip = this.checkIntReceiverZip();
                    var is_receiver_address = this.checkIntReceiverAddress();
                } else {
                    var is_receiver_city = JS_VARS.is_address_in_taiwan == 1 ? this.checkReceiverCity() : true;
                    var is_receiver_district = JS_VARS.is_address_in_taiwan == 1 ? this.checkReceiverDistrict() : true;
                    var is_receiver_zip = JS_VARS.is_address_in_taiwan == 1 ? true : this.checkReceiverZip();
                    var is_receiver_address = this.checkReceiverAddress();
                }

                if (
                    is_receiver_name &&
                    is_receiver_phone &&
                    is_receiver_city &&
                    is_receiver_district &&
                    is_receiver_zip &&
                    is_receiver_address &&
                    is_custom_questions
                ) {
                    this.changeInfo();
                }
            } else if(JS_VARS.is_enable_change_recipient == 1) {
                var is_receiver_name = this.checkReceiverName();
                var is_receiver_phone = this.checkReceiverPhone();
                var is_receiver_email = this.checkReceiverEmail();
                if (
                    is_receiver_name &&
                    is_receiver_phone &&
                    is_receiver_email &&
                    is_custom_questions
                ) {
                    this.changeInfo();
                }
            }
        },
        checkPaynowOverseasReceiverEnglishAddress: function (address) {
            var city = $.trim($('.js_receiver_city').val()) || '';
            var district = $.trim($('.js_receiver_district').val()) || '';
            var zip = $.trim($('.js_receiver_zip').val()) || '';
            var country = $.trim(getInternationCountryName()) || '';
            var fullAddress = address + city + district + zip + country;
            console.log(fullAddress, fullAddress.length);
            console.log(city, district, zip, country);
            return fullAddress.length > 135;
        },
        needCheckInternationalMobile: function () {
            var country = getInternationCountry();
            //如果是 paynow 海外店宅配又是 香港或澳門需要確定國碼
            return (country === 'hk' || country === 'mo') && this.isPaynowOverSeasShipping();
        },
        isPaynowOverSeasShipping: function () {
            return $.inArray(JS_VARS.shipping, ['417', '418']) !== -1;
        },
        isPaynowOverSeasEnglishCountry: function () {
            var country = getInternationCountry();
            return JS_VARS.paynowOverseasChineseCountries.indexOf(country) === -1 && this.isPaynowOverSeasShipping();
        },
        isPaynowOverSeasThailandCountry: function () {
            var country = getInternationCountry();
            return country === 'th' && this.isPaynowOverSeasShipping()
        },
        checkReceiverName : function() {
            var name = $.trim($('#receiver_name').val());
            if (this.isPaynowOverSeasEnglishCountry()) {
                if (!waca.regexValidator.englishName(name) && this.isMaskChange('receiver_name')) {
                    showErrorMessage($('.js_receiver_name_group'), Lang.get('frontend.errormsg.cart.name.format_english'));
                    return false;
                }
            } else if ( ! waca.regexValidator.name(name) && this.isMaskChange('receiver_name')
                || waca.regexValidator.emoji(name)) {
                showErrorMessage($('.js_receiver_name_group'), orderErrorMessage.nameFormat);
                return false;
            }
            hideErrorMessage($('.js_receiver_name_group'));
            return true;
        },
        checkReceiverPhone : function() {
            var phone = $.trim($('#receiver_phone').val());
            var country = getInternationCountry();
            var internationalMobileCodeConfig = {'sg' : '65', 'hk' : '852', 'my' : '60', 'mo' : '853'};
            if (this.needCheckInternationalMobile() && typeof internationalMobileCodeConfig[country] != 'undefined' &&
                !phone.startsWith(internationalMobileCodeConfig[country]) && this.isMaskChange('receiver_phone')) {
                var msg = Lang.get('frontend.errormsg.cart.phone.format3', {
                    countryCode: '('+internationalMobileCodeConfig[country]+')'
                });

                showErrorMessage($('.js_receiver_phone_group'), msg);
                return false;
            } else if (this.isPaynowOverSeasThailandCountry() && this.isMaskChange('receiver_phone')) {
                if (!waca.regexValidator.paynowPhoneTypeA(phone)) {
                    showErrorMessage($('.js_receiver_phone_group'), Lang.get('frontend.errormsg.cart.phone.format5'));
                    return false;
                }

            } else if (! this.checkPhoneByShipping()) {
                return false;
            } else if (!waca.regexValidator.taiwanPhone(phone) && this.isMaskChange('receiver_phone')) {
                showErrorMessage($('.js_receiver_phone_group'), orderErrorMessage.phoneFormat);
                return false;
            }
            hideErrorMessage($('.js_receiver_phone_group'));
            return true;
        },
        checkReceiverEmail : function() {
            if (JS_VARS.is_reservation != 1) {
                return true;
            }
            const value = $.trim($('#receiver_email').val());

            if (!waca.regexValidator.email(value)) {
                showErrorMessage($('.js_receiver_email_group'), orderErrorMessage.emailFormat);
                return false;
            }

            hideErrorMessage($('.js_receiver_email_group'));
            return true;
        },
        checkReceiverCity : function() {
            var city = $('.js_receiver_city').val();
            if ( city === '') {
                showErrorMessage($('.js_receiver_city_group'), orderErrorMessage.IsRequired);
                return false;
            }
            hideErrorMessage($('.js_receiver_city_group'));
            return true;
        },
        checkReceiverDistrict : function() {
            var district = $('.js_receiver_district').val();
            if ( district === '') {
                showErrorMessage($('.js_receiver_district_group'), orderErrorMessage.IsRequired);
                return false;
            }
            hideErrorMessage($('.js_receiver_district_group'));
            return true;
        },
        checkReceiverZip : function() {
            var zip = $.trim($('.js_receiver_zip').val());
            if ( ! waca.regexValidator.zip(zip)) {
                showErrorMessage($('.js_receiver_zip_group'), orderErrorMessage.zipFormat);
                return false;
            }
            hideErrorMessage($('.js_receiver_zip_group'));
            return true;
        },
        checkReceiverAddress : function() {
            var address = $.trim($('#receiver_address').val());

            if ( address === '') {
                showErrorMessage($('.js_receiver_address_group'), orderErrorMessage.IsRequired);
                return false;
            } else if ( ! waca.regexValidator.address(address) && receiverInfo.isMaskChange('receiver_address')) {
                showErrorMessage($('.js_receiver_address_group'), orderErrorMessage.addressFormat);
                return false;
            } else if (receiverInfo.isMaskChange('receiver_address') && waca.regexValidator.asterisk(address)) {
                showErrorMessage($('.js_receiver_address_group'), orderErrorMessage.cannotContainAsterisk);
                return false;
            }

            hideErrorMessage($('.js_receiver_address_group'));
            return true;
        },

        checkIntReceiverCity : function() {
            var city = $('#js_receiver_city').val();
            if ( city === '') {
                showErrorMessage($('.js_int_receiver_city_group'), orderErrorMessage.IsRequired);
                return false;
            } else if (this.isPaynowOverSeasEnglishCountry()) {
                if (!waca.regexValidator.englishAddress(city)) {
                    showErrorMessage($('.js_int_receiver_city_group'), Lang.get('frontend.errormsg.address.city.format_english'));
                    return false;
                }
            }
            hideErrorMessage($('.js_int_receiver_city_group'));
            return true;
        },
        checkIntReceiverDistrict : function() {
            var district = $('#js_receiver_region').val();
            if (district === '') {
                showErrorMessage($('.js_int_receiver_district_group'), orderErrorMessage.IsRequired);
                return false;
            } else if (this.isPaynowOverSeasEnglishCountry()) {
                if (!waca.regexValidator.englishAddress(district)) {
                    showErrorMessage($('.js_int_receiver_district_group'), Lang.get('frontend.errormsg.address.state.format_english'));
                    return false;
                }
            }
            hideErrorMessage($('.js_int_receiver_district_group'));
            return true;
        },
        checkIntReceiverZip : function() {
            var country = getInternationCountry();
            var zip = $.trim($('#intReceiverZip').val());
            if ( ! waca.regexValidator.zip(zip)) {
                showErrorMessage($('.js_int_receiver_zip_group'), orderErrorMessage.zipFormat);
                return false;
            } else if (country !== 'none' && this.isPaynowOverSeasShipping()) {
                if (country === 'my') {
                    if (zip.length !== 5 || !waca.regexValidator.number(zip)) {
                        showErrorMessage($('.js_int_receiver_zip_group'), Lang.get('frontend.errormsg.address.zip.format_number_limit', {
                            number: 5
                        }));
                        return false;
                    }
                }

                if (country === 'sg') {
                    if (zip.length !== 6 || !waca.regexValidator.number(zip)) {
                        showErrorMessage($('.js_int_receiver_zip_group'), Lang.get('frontend.errormsg.address.zip.format_number_limit', {
                            number:6
                        }));
                        return false;
                    }
                }
            }
            hideErrorMessage($('.js_int_receiver_zip_group'));
            return true;
        },
        checkIntReceiverAddress : function() {
            var address = $.trim($('#intReceiverAddress').val());
            if ( address === '') {
                showErrorMessage($('.js_int_receiver_address_group'), orderErrorMessage.IsRequired);
                return false;
            } else if (this.isPaynowOverSeasEnglishCountry() && receiverInfo.isMaskChange('intReceiverAddress')) {
                if (!waca.regexValidator.englishAddress(address)) {
                    showErrorMessage($('.js_int_receiver_address_group'), Lang.get('frontend.errormsg.address.format_english'));
                    return false;
                } else if (this.checkPaynowOverseasReceiverEnglishAddress(address)) {
                    showErrorMessage($('.js_int_receiver_address_group'), Lang.get('frontend.errormsg.address.format135byte'));
                    return false;
                }
            } else if (receiverInfo.isMaskChange('intReceiverAddress') && waca.regexValidator.asterisk(address)) {
                showErrorMessage($('.js_int_receiver_address_group'), orderErrorMessage.cannotContainAsterisk);
                return false;
            }

            hideErrorMessage($('.js_int_receiver_address_group'));
            return true;
        },

        checkCustomQuestions: function(){
            var error = false;
            $('.js_orders_custom_question').each(function(){
                var id = $(this).attr('id');
                var isRequired = $(this).data('required');
                var reply = $.trim($(this).val());
                var errorElm = $(this).closest('.js_custom_question_group');
                if (isRequired == '1' && reply == '') {
                    showErrorMessage(errorElm, orderErrorMessage.IsRequired);
                    error = true;
                } else if (reply != '' && receiverInfo.isMaskChange(id) && waca.regexValidator.asterisk(reply)) {
                    showErrorMessage(errorElm, orderErrorMessage.cannotContainAsterisk);
                    error = true;
                } else if (reply != '' && receiverInfo.isMaskChange(id) && receiverInfo.Blength(reply) > 30) {
                    showErrorMessage(errorElm, orderErrorMessage.customQuestionMaxLength);
                    error = true;
                } else {
                    hideErrorMessage(errorElm);
                }
            });

            return !error;
        },

        isMaskChange : function(id){
            return receiverInfo.maskFields[id] !== $('#' + id).val();
        },
        Blength : function (string) {
            var arr = string.match(/[^\x00-\xff]/ig);
            return  arr == null ? string.length : string.length + arr.length;
        },
        /**
         * if 運送方式等於ezship、allpay、
         *                7-11取貨不付款、
         *                自訂運送(只限台灣)
         *     規則: 限09開頭的手機10碼
         */
        checkPhoneByShipping : function() {
            var phone = $.trim($('#receiver_phone').val());
            if (
                $.inArray(JS_VARS.shipping, ['221','222','241','242','243','244','245','246','247','131']) != -1 ||
                (JS_VARS.shipping.indexOf('custom') != '-1' && JS_VARS.is_address_in_taiwan == 1)
            ) {
                if (! waca.regexValidator.cellphone(phone) && receiverInfo.isMaskChange('receiver_phone')) {
                    showErrorMessage($('.js_receiver_phone_group'), orderErrorMessage.phoneIsRequired);
                    return false;
                }
            }
            return true;
        },
        initGlobalAddress : function () {
            $("#intReceiverCountry").trigger('change')
        },
        initInternationalReceiverAddress : function() {
            $("#js_receiver_region").val(JS_VARS.receiver_address['receiver_district']);
            $("#js_receiver_city").val(JS_VARS.receiver_address['receiver_city']);
        }
    };
    $('.js_change_address_submit').click(function() {
        receiverInfo.init();
    });

    var locale = 'en';
    if ( JS_VARS.getLocale == 'tw' ) {
        locale = 'zh-tw'
    }
    else if ( JS_VARS.getLocale == 'cn' ) {
        locale = 'zh-cn'
    }

    Date.prototype.yyyymmdd = function() {
        var mm = this.getMonth() + 1; // getMonth() is zero-based
        var dd = this.getDate();

        return [this.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var tomorrow_date = tomorrow.yyyymmdd();
    var year = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 365);
    var year_date = year.yyyymmdd();

    if ($('#shipping_date').length > 0) {
        const shippingDatePicker = new TempusDominus(
            document.getElementById('shipping_date'), {
                container: document.querySelector('.date_picker_area'),
                display: {
                    sideBySide: false,
                    viewMode: 'calendar',
                    keepOpen: false,
                    buttons: {
                        today: true,
                        clear: false,
                        close: false
                    },
                    icons: {
                        time: "icon-access_time",
                        date: 'icon-date_range',
                        up: 'icon-arrow_upward',
                        down: 'icon-arrow_downward',
                        previous: 'icon-arrow_back',
                        next: 'icon-arrow_forward',
                        today: 'icon-event',
                        clear: 'icon-delete_forever',
                        close: 'icon-clear'
                    },
                    components: {
                        calendar: true,
                        date: true,
                        month: true,
                        year: true,
                        decades: true,
                        clock: false,
                        hours: false,
                        minutes: false,
                        seconds: false,
                    },
                },
                restrictions: {
                    minDate: tomorrow_date,
                    maxDate: year_date,
                },
                localization: {
                    locale: locale,
                    format: 'yyyy-MM-dd',
                    startOfTheWeek: 0
                },
                useCurrent: false,
            }
        );

        var daysOfWeekDisabled = [];
        if (typeof JS_VARS.is_holiday_send != 'undefined' && JS_VARS.is_holiday_send == '1') {
            daysOfWeekDisabled = [0];
        } else {
            daysOfWeekDisabled = [0,6];
        }

        shippingDatePicker.updateOptions({
            restrictions: {
                disabledDates: JS_VARS.exceptDate,
                daysOfWeekDisabled: daysOfWeekDisabled,
            }
        });
    }

    $("#receiver_region_select").combobox({
        placeholder: '請輸入州/省'
    });

    $("#receiver_city_select").combobox({
        placeholder: '請輸入城市'
    });

    $('#intReceiverCountry').on('change', function() {
        var country = $("option:selected", this).val();
        var countryGeonameID = $("option:selected", this).attr('geonameid');
        var regionElement = $("#receiver_region_select");
        var cityElement = $("#receiver_city_select");

        $("#receiver_city_select option").remove();
        $("#receiver_region_select option").remove();

        if (JS_VARS.noneCityCountry.indexOf(country) >= 0) {

            $('#js_international_district, #js_international_city').addClass('d-none');
            return;
        } else {
            $('#js_international_district, #js_international_city').removeClass('d-none');
        }

        $.ajax({
            url: "/order/city-option",
            type: "POST",
            data: {
                'countryGeonameID': countryGeonameID,
            },
            success: function (response) {
                if (response.result === true) {
                    var options = [];
                    $.each(response.cities, function(key, city)
                    {
                        options.push(
                            '<option value="'+ city.name +'"geonameid="'+ city.geoname_id +'">'
                            + city.name
                            +'</option>'
                        );
                    });
                    cityElement.append(options.join(''));
                    cityElement.val("");
                }
            }
        });

        $.ajax({
            url: "/order/region-option",
            type: "POST",
            data: {
                'countryGeonameID': countryGeonameID,
            },
            success: function (response) {
                if (response.result === true) {
                    var options = [];
                    $.each(response.regions, function(key, region)
                    {
                        options.push(
                            '<option value="'+ region.name +'"geonameid="'+ region.geoname_id +'">'
                            + region.name
                            +'</option>'
                        );
                    });
                    regionElement.append(options.join(''));
                    regionElement.val("");
                }
            }
        });
    });

    $('ul.ui-widget-content').addClass('order_address');
    $('#js_receiver_region, #js_receiver_city').addClass('form_input form_control')
        .closest('.form_select_block')
        .find('.ui-button')
        .attr('data-view', Lang.get('frontend.browsing.history.view'));

    $("#js_receiver_city").on("input change",function() {
        var postReceiverRegionElemet = $('#receiver_city');
        postReceiverRegionElemet.val($(this).val());
    });

    $("#js_receiver_region").on("input change",function() {
        var postReceiverRegionElemet = $('#receiver_region');
        postReceiverRegionElemet.val($(this).val());
    });

    $("#receiver_city_select").on('change', function(){
        var optionCityID = $("option:selected", this).attr("geonameid");
        var postReceiverCityElemet = $('#receiver_city');
        postReceiverCityElemet.val(optionCityID);
    });

    $("#receiver_region_select").on('change', function(){
        var optionRegionID = $("option:selected", this).attr("geonameid");
        var postReceiverRegionElemet = $('#receiver_region');
        postReceiverRegionElemet.val(optionRegionID);
    });

    // 暫停續訂
    $('#js_pause_subscription').click(function(){
        changeSubscriptionStatus(Lang.get('frontend.order.subscription_status.btn.suspend.info'), 'pause');
    });

    // 重新續訂
    $('#js_continue_subscription').click(function(){
        changeSubscriptionStatus(Lang.get('frontend.order.subscription_status.btn.restart.info'), 'continue');
    });

    // 再次續訂
    $('#js_create_cycle_subscription').click(function(){
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-5 col-xl-4',
            content: false,
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: Lang.get('frontend.order.subscription_status.btn.renew.info'),
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function() {
                        $('#subscriptionQuery').attr('action', JS_VARS.urls.createCycleSubscriptionOrder);
                        $('#subscriptionQuery').submit();

                        return true;
                    }
                }
            },
            backgroundDismiss: false,
            onOpenBefore: function() {
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.confirmButtonHoverStyle);

                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                this.$el.find('.btn_cancel, .btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            }
        });

        return false;
    });

    var getInternationCountryName = function () {
        return $('#intReceiverCountry').data('name');
    }

    var getInternationCountry = function() {
        return $('#intReceiverCountry').val();
    };

    // 重新授權
    $('#js_reauthorize_subscription').click(function(){
        $('#subscriptionQuery').attr('action', JS_VARS.urls.subscriptionReAuthroize);
        $('#subscriptionQuery').submit();
    });

    // 變更扣款信用卡
    $('#js_change_credit_card').click(function(event){
        event.preventDefault();
        $('#subscriptionQuery').attr('action', JS_VARS.urls.changeCreditCard);
        $('#subscriptionQuery').submit();
    });

    function changeSubscriptionStatus(configMessage, action)
    {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-5 col-xl-4',
            content: false,
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: configMessage,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        $.ajax({
                            type: 'POST',
                            url: JS_VARS.urls.changeSubscriptionAjax,
                            data: {
                                'order_no': JS_VARS.orders_no,
                                'order_query_token': JS_VARS.orderQueryToken,
                                'action': action
                            },
                            success: function (data) {
                                if (!data.status) {
                                    new AlertMessage({
                                        'title': data.errormsg,
                                        'confirm': function(){
                                            if (data.query_token_expire) {
                                                reloadPage();
                                            }
                                        }
                                    }).handle();
                                } else {
                                    reloadPage();
                                }
                            },
                            dataType: 'json'
                        });
                        return true;
                    },
                }
            },
            backgroundDismiss: false,
            onOpenBefore: function() {
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.confirmButtonHoverStyle);

                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                this.$el.find('.btn_cancel, .btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            }
        });

        return false;


    }

    // 訂單查詢頁 reload
    function reloadPage()
    {
        var form = document.createElement("form");
        var orderNoInput = document.createElement("input");
        var orderQueryTokenInput = document.createElement("input");

        form.method = "POST";
        form.action = JS_VARS.urls.orderquery;

        orderNoInput.value=JS_VARS.orders_no;
        orderNoInput.name="order_no";
        orderNoInput.type="hidden";
        form.appendChild(orderNoInput);

        orderQueryTokenInput.value=JS_VARS.orderQueryToken;
        orderQueryTokenInput.name="order_query_token";
        orderQueryTokenInput.type="hidden";
        form.appendChild(orderQueryTokenInput);

        document.body.appendChild(form);

        form.submit();
    }

    // 開啟組合商品明細 //舊的js 不用補
    $('#js_order_cart_list').on('change', 'input[name="cart_bundle_sales"]', function(){
        setCartBundleItemStyle($(this).attr('id'));
    });

    // 設定我的購物車，組合包樣式
    function setCartBundleItemStyle(bundleId) {
        const isOpen = $('input#' + bundleId).is(':checked');
        const bundleSwitchDom = $('.bundle_sales_switch[for="'+bundleId+'"]');

        if (isOpen) {
            bundleSwitchDom.attr('style', bundleSwitchDom.data('active-style'));
        } else {
            bundleSwitchDom.attr('style', bundleSwitchDom.data('style'));
        }
    }

    $('input[name="atm_accordion"]').change(function(){
        const labelDom = $(this).next('label');
        $('.js_atm_accordion_label').attr('style', labelDom.data('style'));

        labelDom.attr('style', labelDom.data('active-style'));
    });
});
